import React from 'react';
import {ControllerFieldState} from 'react-hook-form';
import {InputAdornment, TextField} from '@mui/material';
import {MaskedInput} from 'presentation/components';
import {masks, formatCurrency} from 'presentation/utils';
import {translations} from 'presentation/translations-new';
import {TherapyIdField, TherapyServiceDateField, TherapySessionValueField} from './types';

const {currencyUnit} = translations['pt-br'].commons;

const renderHiddenIdField = ({field}: {field: TherapyIdField}) => (
	<input type="hidden" {...field} />
);

const renderServiceDateField =
	(index: number, placeholderDate: string, handleAction: () => void, clearError: () => void) =>
	({
		field,
		fieldState: {error},
	}: {
		field: TherapyServiceDateField;
		fieldState: ControllerFieldState;
	}) => (
		<MaskedInput
			{...field}
			$fieldName={`sessions.${index}.serviceDate`}
			value={field.value || ''}
			inputMode="text"
			error={!!error}
			helperText={error?.message}
			fullWidth
			placeholder={placeholderDate}
			maskOptions={masks.birthday}
			label={placeholderDate}
			endAdornmentVariant="button"
			endAdornmentIcon="calendar-focused-filled"
			handleAction={handleAction}
			onChange={event => {
				clearError();
				field.onChange(event.target.value);
			}}
			slotProps={{
				inputLabel: {
					shrink: true,
				},
			}}
		/>
	);

const renderSessionValueField =
	(placeholderValue: string, clearError: () => void) =>
	({
		field,
		fieldState: {error},
	}: {
		field: TherapySessionValueField;
		fieldState: ControllerFieldState;
	}) => (
		<TextField
			{...field}
			value={field.value || '0,00'}
			onChange={event => {
				clearError();
				const formatted = formatCurrency(event.target.value);
				field.onChange(formatted);
			}}
			error={!!error}
			helperText={error?.message}
			fullWidth
			placeholder={placeholderValue}
			label={placeholderValue}
			slotProps={{
				input: {
					startAdornment: (
						<InputAdornment position="start">{currencyUnit} </InputAdornment>
					),
				},
				htmlInput: {
					inputMode: 'decimal',
				},
				inputLabel: {
					shrink: true,
				},
			}}
		/>
	);

export {renderHiddenIdField, renderServiceDateField, renderSessionValueField};
